import { render, staticRenderFns } from "./addProjectForm.vue?vue&type=template&id=4edfcc5e&scoped=true"
import script from "./addProjectForm.vue?vue&type=script&lang=js"
export * from "./addProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edfcc5e",
  null
  
)

export default component.exports